import { transformErrorUiProps } from 'errors';

import HttpService from 'services/HttpService';

import { API_URLS } from 'constants/apiUrls';

export enum ConsentType {
  EPro = 'e_pro',
  TwoWayMessaging = '2_way_messaging',
  HomecareInstructions = 'homecare_instructions'
}

export enum ConsentStatus {
  Pending = 'pending',
  Approved = 'approved',
  Denied = 'denied'
}

export interface ConsentRequestBody {
  patientId: number;
  consentType: ConsentType;
  consentStatus: ConsentStatus;
  metadata?: unknown;
}

const httpService = new HttpService('patient communication');

export class ConsentFetcher {
  static async saveConsent(consentRequestBody: ConsentRequestBody) {
    return await httpService.post({
      url: API_URLS.CONSENTS,
      data: consentRequestBody,
      transformError: transformErrorUiProps('Failed to save consent')
    });
  }
}
